
import React from "react";
import { Nav, Accordion } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLocation } from "react-router-dom";
import "./sidebar.css";

const CollapsableSidebarItem = (props) => {
  const { eventKey, title, icon, children = null } = props;
  const location = useLocation();
  const { pathname } = location;
  
  const defaultKey = pathname.indexOf(eventKey) !== -1 ? eventKey : "";

  return (
    <Accordion as={Nav.Item} defaultActiveKey={defaultKey} className="custom-sidebar-collapsable">
      <Accordion.Item eventKey={eventKey} className="custom-sidebar-collapsable">
        <Accordion.Button as={Nav.Link} className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <span className="sidebar-icon"><FontAwesomeIcon icon={icon} /> </span>
            <span className="sidebar-text">{title}</span>
          </div>
        </Accordion.Button>
        <Accordion.Body className="multi-level">
          <Nav className="flex-column">
            {children}
          </Nav>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default CollapsableSidebarItem;
